import { api, ApiTags } from '../../api';
import type {
    UserScoreAndRankResponse,
    UserScoreAndRankRequest,
    LeaderboardTopResponse,
    LeaderboardTopRequest,
} from './types';

/**
 * API сервис для работы с лидербордом
 */
const leaderboardApi = api.injectEndpoints({
    endpoints: build => ({
        /**
         * Получает score и rank текущего пользователя
         * В тестовых окружениях использует тестовые данные из query-параметров
         */
        getUserScoreAndRank: build.query<UserScoreAndRankResponse, UserScoreAndRankRequest>({
            query: (params = {}) => ({
                url: '/leaderboard/score-and-rank',
                params: { loginOrPublicId: params?.loginOrPublicId },
            }),
            providesTags: [{ type: ApiTags.Leaderboard, id: 'USER_SCORE_AND_RANK' }],
        }),
        /**
         * Получает топ 100 лидеров
         * В тестовых окружених генерирует мок-данные и заменяет строку с rank из query-параметров
         */
        getLeaderboardTop: build.query<LeaderboardTopResponse, LeaderboardTopRequest>({
            query: () => ({
                url: '/leaderboard/top',
            }),
            providesTags: [{ type: ApiTags.Leaderboard, id: 'TOP' }],
        }),
    }),
});

export const { useGetUserScoreAndRankQuery, useGetLeaderboardTopQuery } = leaderboardApi;
